<template>
    <main class="main-content disclaimer" style="background-image: url(/assets/img/slide-03.jpg);">
        <section class="content">
            <div class="brand">
                <img src="/assets/img/logo-monvin-dark.svg" alt="Monvin">
            </div>
            <div class="disclaimer-mobile-image">
                <img src="/assets/img/slide-03.jpg">
            </div>
            <h2 v-t="'disclaimer.title'"></h2>
            <p v-html="$t('disclaimer.content')"></p>
            <div class="verify-form">
                <div class="field">
                    <label for="country" class="label" v-t="'disclaimer.form.location'"></label>
                        <!-- <select v-model="activeCountry" name="country" id="country">
                            <option value="" v-t="'disclaimer.form.select'"></option>
                            <option v-for="country in countries" :value="country.countryCode" v-text="country.countryName"></option>
                        </select> -->

                        <v-select v-model="activeCountry" :options="options"></v-select>
                </div>
                <div class="field">
                    <label for="year" class="label" v-t="'disclaimer.form.birthdate'"></label>
                    <div class="is-medium">
                        <!-- <select v-model="birthdate" name="year" id="year">
                            <option v-for="n in 100" :value="getYear( n )" v-text="getYear( n )"></option>
                        </select> -->
                        <v-select v-model="birthdate" :options="years"></v-select>
                    </div>
                </div>
            </div>
            <div v-if="notification" class="notification is-danger is-uppercase is-bold" v-t="'disclaimer.notification'"></div>
            <button @click.prevent="accept" :disabled="! authorized" class="button" v-t="'disclaimer.form.submit'"></button>
        </section>

        <section class="disclaimer-footer has-text-centered">
            <p class="is-uppercase"><strong v-t="'disclaimer.footer.1'"></strong></p>
            <p class="is-uppercase"><strong v-t="'disclaimer.footer.2'"></strong></p>
            <p v-t="'disclaimer.footer.3'"></p>
            <p><router-link tag="a" :to="{ name: $i18n.locale+'.contact' }" v-t="'menu.newsletter'"></router-link></p>
        </section>
    </main>
</template>
<script>
    import axios from 'axios'
    import Cookie from 'js-cookie'
    import vSelect from 'vue-select'

    export default {
        components: {
            vSelect
        },
        data() {
            return {
                lang: 'en',
                birthdate: (new Date).getFullYear(),
                authorized: false,
                notification: false,
                countries: [],
                activeCountry: ''
            }
        },
        mounted() {
            if( Cookie.get('monvin-disclaimer-confirm') ) {
                this.$router.push({name: 'home'})
                return
            }
            this.lang = this.$i18n.locale
            axios.get( `https://secure.geonames.org/countryInfoJSON?username=coolmind2`)
                .then( response => {
                    this.countries = response.data.geonames
                })
            this.getLocation();
        },
        computed: {
            options() {
                let options = [{label: this.$t('disclaimer.form.select'), value: ''}];
                for( let country of this.countries ) {
                    options.push({
                        label: country.countryName,
                        value: country.countryCode
                    });
                }
                return options;
            },
            years() {
                let options = [];
                for( let n = 1; n <= 100; n++ ) {
                    options.push( this.getYear( n ) )
                }
                return options;
            }
        },
        methods: {
            accept() {
                if( this.authorized ) {
                    Cookie.set('monvin-disclaimer-confirm', 'accepted', { expires: 30 });
                    this.$router.push({name: 'home'})
                }
            },
            getYear( n ) {
                let number = n - 1;
                return (new Date).getFullYear() - number;
            },
            getLocation() {
                navigator.geolocation.getCurrentPosition( ( position ) => {
                    // axios.get( `https://secure.geonames.org/countryCodeJSON?lat=${position.coords.latitude}&lng=${position.coords.longitude}&username=coolmind2`)
                    axios.get( `https://secure.geonames.org/countryCodeJSON?lat=35.652832&lng=139.839478&username=coolmind2`)
                        .then( response => {
                            this.activeCountry = { value: response.data.countryCode, label: response.data.countryName }
                        } )
                } );
            }
        },
        watch: {
            lang() {
                this.$i18n.locale = this.lang
            },
            activeCountry() {
                if( this.activeCountry && this.activeCountry.value === 'IT' ) {
                    this.lang = 'it'
                } else {
                    this.lang = 'en'
                }
            },
            birthdate( birthdate ) {
                this.authorized = birthdate <= ((new Date).getFullYear() - 21)
                this.notification = ! this.authorized
            }
        }
    }
</script>